import { render, staticRenderFns } from "./TransactionList.vue?vue&type=template&id=17718614&"
import script from "./TransactionList.vue?vue&type=script&lang=js&"
export * from "./TransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17718614')) {
      api.createRecord('17718614', component.options)
    } else {
      api.reload('17718614', component.options)
    }
    module.hot.accept("./TransactionList.vue?vue&type=template&id=17718614&", function () {
      api.rerender('17718614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pacs008/SDD/TransactionList.vue"
export default component.exports